import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage } from 'react-intl'
import {
  Accordion, AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  InputAdornment,
  Typography
} from '@material-ui/core'
import { AddNewLineItemFormValidation } from '../../../../utils/validationSchema'
import { FormLoader } from '../../../Loader/FormLoader'
import FormSelectField from '../../../../FormFields/FormSelectField'
import FormTextField from '../../../../FormFields/FormTextField'
import FormEntityListField from '../../../../FormFields/FormEntityListField'
import unitTypes from '../../../../configurations/unit-types'
import weightTypes from '../../../../configurations/weight-types'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import MoneyOffIcon from '@material-ui/icons/MoneyOff'
import FormListAddMore from '../../../../FormFields/FormListAddMore'
import { InvoiceItemProvider, InvoiceItemConsumer } from '../../../../context/InvoiceItemContext'
import FormEntityLoadField from '../../../../FormFields/FormEntityLoadField'
import { ListingProvider, ListingConsumer } from '../../../../context/ListingContext'
import CenterFocusWeakIcon from '@material-ui/icons/CenterFocusWeak'
import { useStyles } from './Styles'
import Alert from '@material-ui/lab/Alert'

const InvoiceItemForm = ({ item, onSubmit, cancelDialog, locale, formClasses, currentDialogAction, currencies, updateCurrenciesList, documentType }) => {
  const classes = useStyles()
  const [codeType, setCodeType] = React.useState(item?.itemType || 'GS1')
  const [taxes, setTaxes] = React.useState([])
  const [itemCodeEdit, setItemCodeEdit] = React.useState(item?.itemCode)
  const [itemObject, setItemObject] = React.useState(item?.itemObject || {})
  const itemLineForm = useFormik({
    initialValues: {
      id: '',
      documentType: documentType || '',
      itemType: 'GS1',
      itemCode: '',
      itemName: '',
      description: '',
      itemObject: {},
      codeFilter: {
        CodeLookupValue: '',
        CodeName: '',
        OnlyActive: false
      },
      internalCode: '',

      unitCalculatedValue: 0,
      unitAmount: '',
      currencyRate: {
        id: 0,
        key: 'EGP',
        name_en: 'Egyptian Pound',
        name_ar: 'جنيه مصري',
        rate: 1
      },
      amountSold: 'EGP',

      unitType: 'KGM',
      quantity: 1,

      weightUnitType: '',
      weightQuantity: 0,

      calculatedSalesTotal: 0,
      salesTotalEdit: false,
      salesTotal: 0,

      discountRate: 0,
      discountValue: 0,
      discountValueEdit: false,
      discountCalculatedValue: 0,

      netTotal: 0,
      netTotalEdit: false,
      calculatedNetTotal: 0,

      taxableItems: [],
      totalTaxableItems: 0,
      calculatedTaxesWithoutT1: 0,

      totalTaxableFees: 0,
      totalTaxableFeesEdit: false,
      calculatedTotalTaxableFees: 0,


      valueDifference: 0,
      itemsDiscount: 0,

      total: 0,
      totalEdit: false,
      calculatedTotal: 0,

      deleted: false,
      invoiceUUID: '',
      originItemValues: null
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    // isInitialValid: false,
    validationSchema: AddNewLineItemFormValidation,
    onSubmit: ((values, actions) => {
      onSubmit(values, actions)
    })
  })

  React.useEffect(() => {
      if (!!Object.keys(itemObject || {}).length || !itemObject) {
        itemLineForm.setFieldValue('itemObject', itemObject)
        itemLineForm.setFieldValue('itemName', locale === 'ar' ? (itemObject?.codeNameSecondaryLang ||
          itemObject?.codeNamePrimaryLang) : itemObject?.codeNamePrimaryLang)
        if (!(!!itemCodeEdit && itemCodeEdit === item?.itemCode) || !itemCodeEdit) {
          itemLineForm.setFieldValue('description', !!Object.keys(itemObject || {}).length ?
            (locale === 'ar' ? (itemObject.codeDescriptionSecondaryLang ||
              itemObject.codeNameSecondaryLang || itemObject.codeDescriptionPrimaryLang
              || itemObject.codeNamePrimaryLang || '') : (itemObject.codeDescriptionPrimaryLang
              || itemObject.codeNamePrimaryLang || ''))
            : '')
          if (!!Object.keys(itemObject || {})?.length && itemLineForm.values.description !== item?.description) {
            itemLineForm.setFieldTouched('description', true, false)
          }
        }
        setItemCodeEdit(null)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [itemObject])


  React.useEffect(() => {
      if (!!Object.keys(item || {}).keys()) {
        setTaxes([...(item?.taxableItems || [])])
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  return (
    <Box px={4} pt={1} pb={4}>
      <InvoiceItemProvider itemLineForm={itemLineForm} item={item} currentDialogAction={currentDialogAction}
                           documentType={documentType}>
        <InvoiceItemConsumer>
          {({
              DecimalChange, DecimalBlur, handleSwitchEditChange, RateChange, updateTotalTaxableFees,
              discountValueEdit, setDiscountValueEdit, salesTotalEdit, setSalesTotalEdit,
              totalTaxableFeesEdit, setTotalTaxableFeesEdit, netTotalEdit, setNetTotalEdit,
              totalEdit, setTotalEdit, codeFilter
            }) => (
            <form onSubmit={itemLineForm.handleSubmit} noValidate autoComplete="off"
                  className={formClasses.formWrapper}>

              {!!item?.invoiceUUID &&
              <Alert severity="warning" className={formClasses.alert}>
                <FormattedMessage id={`InvoicesReference.items.AlertHint.${documentType}`} values={{
                  strong: chunks => <strong>{chunks}</strong>
                }}/>
              </Alert>
              }


              <FormSelectField name={'itemType'} labelKey={'Fields.label.itemType'}
                               classes={formClasses} type={'itemType'} setFilter={setCodeType}
                               formActions={itemLineForm} required disabled={!!item?.invoiceUUID}/>

              <FormTextField name={'internalCode'} labelKey={'Fields.label.internalCode'} classes={formClasses}
                             formActions={itemLineForm} disabled={!!item?.invoiceUUID}/>

              <ListingProvider entityName={'codesSearch'} codeType={codeType || 'GS1'}
                               codeTypeChanged={codeType} disableDefaultSearch
                               initFilter={codeFilter}
                               listingPaging={{
                                 Ps: 100,
                                 Pn: 1,
                                 // OnlyActive: true,
                                 // OnlyActive: codeType === 'GS1' ? true : '',
                                 ApplyMinChoiceLevel: true,
                                 CodeTypeLevelNumber: 5
                               }}>
                <ListingConsumer>
                  {({ listingData, listingLoading, handleListingFilterSubmit }) => (
                    <FormEntityLoadField formActions={itemLineForm} classes={formClasses} name={'itemCode'}
                                         codeFilter={itemLineForm.values.codeFilter} codeType={codeType}
                                         setReturnedObj={setItemObject} optionKey={'codeLookupValue'} row
                                         entityKey={'codeLookupValue'} loading={listingLoading} list={listingData}
                                         searchable={'CodeLookupValue'} loadEntities={handleListingFilterSubmit}
                                         labelKey={'Fields.label.itemCode'} required disabled={!!item?.invoiceUUID}
                                         getOptionLabel={(option) => !!option?.codeLookupValue ? (Object.keys(option)?.length > 1 ? (`${locale === 'ar' ? option.codeNameSecondaryLang || option.codeNamePrimaryLang : option.codeNamePrimaryLang} (${option.codeLookupValue})` || '') : (option.codeLookupValue || '')) : ''}
                                         renderOption={(option, selected) => {
                                           return <React.Fragment>
                                             {!!option.codeLookupValue &&
                                             <div className={classes.optionWrapper}>
                                               <CenterFocusWeakIcon color={'primary'}/>
                                               <div className={classes.optionContainer}>

                                                 <div className={classes.optionParent}>
                                                   {(!!option.parentCodeNamePrimaryLang ||
                                                     (locale === 'ar' && !!option.parentCodeNameSecondaryLang)) ?
                                                     (locale === 'ar' ? option.parentCodeNameSecondaryLang || option.parentCodeNamePrimaryLang : option.parentCodeNamePrimaryLang)
                                                     : <FormattedMessage id={'codesSearch.NoParent'}/>}
                                                 </div>
                                                 <div className={classes.option}>
                                                   {locale === 'ar' ? option.codeNameSecondaryLang || option.codeNamePrimaryLang : option.codeNamePrimaryLang}
                                                   <span className={classes.optionID}>
                                                     ({option.codeLookupValue})
                                                   </span>
                                                 </div>
                                               </div>
                                             </div>
                                             }
                                           </React.Fragment>
                                         }}/>
                  )}
                </ListingConsumer>
              </ListingProvider>


              <FormTextField name={'description'} labelKey={'Fields.label.description'} classes={formClasses}
                             formActions={itemLineForm} row lines={3} required disabled={!!item?.invoiceUUID}/>

              <FormTextField name={'quantity'} labelKey={'Fields.label.quantity'} classes={formClasses}
                             formActions={itemLineForm} required
                             onChange={(event) => DecimalChange(event, 'quantity')}
                             onBlurFn={(event) => DecimalBlur(event, 'quantity')}
                             originValue={item?.originItemValues?.quantity}
              />

              <FormSelectField name={'unitType'} labelKey={'Fields.label.unitType'}
                               classes={formClasses} list={unitTypes} locale={locale} withKey
                               formActions={itemLineForm} required disabled={!!item?.invoiceUUID}/>

              <FormEntityListField entityName={'currency'} list={currencies} locale={locale}
                                   name={'amountSold'} labelKey={'Fields.label.amountSold'}
                                   returnedObjectKey={'currencyRate'}
                                   disabled={!!item?.invoiceUUID}
                                   classes={formClasses} formActions={itemLineForm} required withKeyNext addMore
                                   updateParentEntity={(value) => {
                                     updateCurrenciesList(value)
                                   }}/>

              <FormTextField name={'unitAmount'} labelKey={'Fields.label.unitAmount'} classes={formClasses}
                             formActions={itemLineForm} required
                             onChange={(event) => DecimalChange(event, 'unitAmount')}
                             onBlurFn={(event) => DecimalBlur(event, 'unitAmount')}
                             originValue={item?.originItemValues?.unitAmount}
                             otherAttributes={{
                               InputProps: {
                                 endAdornment: <InputAdornment position="end">
                                   <strong>{itemLineForm.values.amountSold}</strong>
                                 </InputAdornment>
                               }
                             }}/>

              {['EI', 'EC', 'ED'].includes(documentType?.toUpperCase()) &&
              <>
                <FormTextField name={'weightQuantity'} labelKey={'Fields.label.weightQuantity'} classes={formClasses}
                               formActions={itemLineForm} required
                               onChange={(event) => DecimalChange(event, 'weightQuantity')}
                               onBlurFn={(event) => DecimalBlur(event, 'weightQuantity')}
                               originValue={item?.originItemValues?.weightQuantity}
                />
                <FormSelectField name={'weightUnitType'} labelKey={'Fields.label.weightUnitType'} displayEmpty
                                 classes={formClasses} list={weightTypes} locale={locale}
                                 formActions={itemLineForm} required/>
              </>
              }
              <FormTextField name={'salesTotal'} labelKey={'Fields.label.salesTotal'} classes={formClasses} row
                             switchEdit={!item?.invoiceUUID} switchEditValue={salesTotalEdit}
                             handleSwitchEdit={(value) => handleSwitchEditChange(value, setSalesTotalEdit, 'salesTotal')}
                             formActions={itemLineForm} required
                             originValue={item?.originItemValues?.salesTotal}
                             disabled={!!item?.invoiceUUID}
                             onChange={(event) => DecimalChange(event, 'salesTotal')}
                             onBlurFn={(event) => DecimalBlur(event, 'salesTotal')}
                             InputAttributes={{
                               startAdornment: <InputAdornment position="start">
                                 <strong>{itemLineForm.values.amountSold}</strong>
                               </InputAdornment>
                             }}/>


              <div className={formClasses.FormItem + ' ' + formClasses.FormRow}>
                <Accordion elevation={2} className={formClasses.FormAccordion}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    className={formClasses.AddressCollapseWrapper}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography className={formClasses.ItemHeading}>
                      <MoneyOffIcon/><FormattedMessage id={'Fields.label.discount'}/></Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className={formClasses.formWrapper}>
                      <FormTextField name={'discountRate'} labelKey={'Fields.label.discountRate'}
                                     classes={formClasses}
                                     formActions={itemLineForm}
                                     onChange={(event) => RateChange(event, 'discountRate')}
                                     onBlurFn={(event) => DecimalBlur(event, 'discountRate')}
                                     originValue={item?.originItemValues?.discountRate}
                                     disabled={!!item?.invoiceUUID}
                                     otherAttributes={{
                                       InputProps: {
                                         endAdornment: <InputAdornment position="end">%</InputAdornment>
                                       }
                                     }}/>
                      <FormTextField name={'discountValue'} labelKey={'Fields.label.discountValue'}
                                     classes={formClasses}
                                     switchEdit={!item?.invoiceUUID} switchEditValue={discountValueEdit}
                                     handleSwitchEdit={(value) => handleSwitchEditChange(value, setDiscountValueEdit, 'discountValue')}
                                     formActions={itemLineForm}
                                     originValue={item?.originItemValues?.discountValue}
                                     disabled={!!item?.invoiceUUID}
                                     onChange={(event) => DecimalChange(event, 'discountValue')}
                                     onBlurFn={(event) => DecimalBlur(event, 'discountValue')}
                                     specialError={parseFloat(itemLineForm.values.discountValue) > parseFloat(itemLineForm.values.salesTotal) ?
                                       <FormattedMessage id={'itemLineForm.ExceedDiscount.hint'}/> : null}
                                     InputAttributes={{
                                       startAdornment: <InputAdornment position="start">
                                         {itemLineForm.values.amountSold}
                                       </InputAdornment>
                                     }}/>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>

              <FormListAddMore labelKey={'Fields.label.taxableItems'} entityName={'taxableItems'}
                               currentData={item} classes={formClasses}
                               netTotal={itemLineForm.values.netTotal}
                               totalTaxableFees={itemLineForm.values.calculatedTaxesWithoutT1}
                               calculatedFees={itemLineForm.values.calculatedTotalTaxableFees}
                               valueDifference={itemLineForm.values.valueDifference}
                               currency={itemLineForm.values.amountSold}
                               locale={locale}
                               list={taxes}
                               updateParentEntity={(value) => {
                                 setTimeout(() => updateTotalTaxableFees(value), 10)
                                 itemLineForm.setFieldValue('taxableItems', value)
                               }}
              />


              <div className={formClasses.FormTotals}>

                <FormTextField name={'totalTaxableFees'} labelKey={'Fields.label.totalTaxableFees'}
                               classes={formClasses}
                               switchEdit={!item?.invoiceUUID} switchEditValue={totalTaxableFeesEdit}
                               handleSwitchEdit={(value) => handleSwitchEditChange(value, setTotalTaxableFeesEdit, 'totalTaxableFees')}
                               formActions={itemLineForm}
                               originValue={item?.originItemValues?.totalTaxableFees}
                               disabled={!!item?.invoiceUUID}
                               onChange={(event) => DecimalChange(event, 'totalTaxableFees')}
                               onBlurFn={(event) => DecimalBlur(event, 'totalTaxableFees')}
                               InputAttributes={{
                                 startAdornment: <InputAdornment position="start">
                                   {itemLineForm.values.amountSold}
                                 </InputAdornment>
                               }}/>
                <FormTextField name={'valueDifference'} labelKey={'Fields.label.valueDifference'}
                               classes={formClasses}
                               formActions={itemLineForm}
                               onChange={(event) => DecimalChange(event, 'valueDifference', true)}
                               onBlurFn={(event) => DecimalBlur(event, 'valueDifference')}
                               originValue={item?.originItemValues?.valueDifference}
                               disabled={!!item?.invoiceUUID}
                               InputAttributes={{
                                 startAdornment: <InputAdornment position="start">
                                   {itemLineForm.values.amountSold}
                                 </InputAdornment>
                               }}/>

                <FormTextField name={'itemsDiscount'} labelKey={'Fields.label.itemsDiscount'} classes={formClasses}
                               formActions={itemLineForm}
                               onChange={(event) => DecimalChange(event, 'itemsDiscount')}
                               onBlurFn={(event) => DecimalBlur(event, 'itemsDiscount')}
                               originValue={item?.originItemValues?.itemsDiscount}
                               disabled={!!item?.invoiceUUID}
                               InputAttributes={{
                                 startAdornment: <InputAdornment position="start">
                                   {itemLineForm.values.amountSold}
                                 </InputAdornment>
                               }}/>


                <FormTextField name={'netTotal'} labelKey={'Fields.label.netTotal'} classes={formClasses}
                               switchEdit={!item?.invoiceUUID} switchEditValue={netTotalEdit}
                               handleSwitchEdit={(value) => handleSwitchEditChange(value, setNetTotalEdit, 'netTotal')}
                               formActions={itemLineForm} required
                               originValue={item?.originItemValues?.netTotal}
                               disabled={!!item?.invoiceUUID}
                               onChange={(event) => DecimalChange(event, 'netTotal')}
                               onBlurFn={(event) => DecimalBlur(event, 'netTotal')}
                               InputAttributes={{
                                 startAdornment: <InputAdornment position="start">
                                   {itemLineForm.values.amountSold}
                                 </InputAdornment>
                               }}/>

                <FormTextField name={'total'} labelKey={'Fields.label.total'} classes={formClasses}
                               switchEdit={!item?.invoiceUUID} switchEditValue={totalEdit}
                               handleSwitchEdit={(value) => handleSwitchEditChange(value, setTotalEdit, 'total')}
                               formActions={itemLineForm} required
                               onChange={(event) => DecimalChange(event, 'total')}
                               onBlurFn={(event) => DecimalBlur(event, 'total')}
                               originValue={item?.originItemValues?.total}
                               disabled={!!item?.invoiceUUID}
                               InputAttributes={{
                                 startAdornment: <InputAdornment position="start">
                                   {itemLineForm.values.amountSold}
                                 </InputAdornment>
                               }}/>

              </div>

              <div className={formClasses.FormSubmitRow}>
                <Button type="submit" variant='contained' size={'large'} color={'secondary'}
                        onClick={itemLineForm.handleSubmit}
                        disabled={itemLineForm.isSubmitting || !itemLineForm.isValid}
                >
                  <FormattedMessage id='invoiceSteps.receiver.address.submit'/>
                </Button>
                <Button variant='outlined' color='secondary'
                        onClick={cancelDialog} className={'cancel'}>
                  <FormattedMessage id='invoiceSteps.Cancel'/>
                </Button>
              </div>
              {!!itemLineForm.isSubmitting && <FormLoader loading={true}/>}
            </form>
          )}
        </InvoiceItemConsumer>
      </InvoiceItemProvider>
    </Box>
  )
}

export default InvoiceItemForm
